import { setLoginClickHandler } from '../authentication'
import { FEATURES_LIST } from './strings'
import { gettext, modals } from '../../services'
import { PREMIUM_URL } from '../../settings'

export default function showPremiumModal(options = {}) {
    const checkoutUrl = PREMIUM_URL +
        '?utm_source=website&utm_medium=premium_modal&utm_campaign=unlock_premium_features' +
        '#premium-plans'
    modals.show('premium', {
        icon: '#premium-badge',
        title: gettext('Unlock all exclusive features with Bikemap Premium'),
        body: FEATURES_LIST,
        footer: '<a id="premium-modal-checkout" class="btn btn-premium" href="' + checkoutUrl + '">' +
                    gettext('Go Premium') +
                '</a>' +
                '<p class="mt mb-0 bm-login-hide">' +
                    gettext('You need a free Bikemap account first.') + ' <a href="#log-in">' + gettext('Sign up here') + '</a>' +
                '</p>',
        init: modal => {
            setLoginClickHandler(modal.node)
            const checkoutLink = modal.footer.querySelector('#premium-modal-checkout')
            if (options.onSubmit) {
                checkoutLink.addEventListener('click', options.onSubmit)
            }
        },
        onClose: options.onClose,
    })
}
